import React, { useState, useRef } from "react";
import {
  Box,
  InputLabel,
  FormControl,
  InputAdornment,
  TextField,
  Divider,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AutoComplete from "../../../AutoComplete/AutoComplete";
import { ActionButtons } from "../../../CancelSave";
import { useCreateEmailNotificationLocationMutation } from "../../../../services/emailNotificationLocationSlice/emailNotificationLocationSlice";

type EmailNotificationLocation = {
  notificationType: string;
  id: string;
  subject: string;
  notificationNotes: string;
  triggerType: string;
};

const AddTaskNotificationEmail = ({
  notificationsData,
  setHandle,
  taskId,
}: {
  notificationsData: EmailNotificationLocation[];
  setHandle: React.Dispatch<React.SetStateAction<string>>;
  taskId: number;
}) => {
  const [showNotificationDropdown, setShowNotificationDropdown] =
    useState(false);
  const [selectedTaskObj, setSelectedTaskObj] =
    useState<EmailNotificationLocation | null>(null);

  const notificationRef = useRef(null);

  const [createEmailNotificationLocation] = useCreateEmailNotificationLocationMutation();

  const handleSave = async () => {
   await createEmailNotificationLocation({
      body: {
        subject: selectedTaskObj?.subject || "",
        locationType: "task",
        taskId: taskId, // You can replace this with the actual task ID if available
        emailNotificationId: selectedTaskObj?.id || "",
        template: true,
        triggerType: selectedTaskObj?.triggerType || "",
      }
      });
    setShowNotificationDropdown(false);
    setHandle("");
  };


  return (
    <>
      <Box mt={3} />
      <Box ml={4}>
        <InputLabel>Choose a Email</InputLabel>
      </Box>
      <FormControl
        sx={{ m: 4, mt: 1, width: "-webkit-fill-available" }}
        size="small"
      >
        <TextField
          ref={notificationRef}
          size="small"
          value={selectedTaskObj?.subject || ""}
          sx={{ width: { xs: "100%" } }}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <ArrowDropDownIcon />
              </InputAdornment>
            ),
          }}
          onClick={() => setShowNotificationDropdown(true)}
        />
        <AutoComplete
          data={[...notificationsData]}
          type="task"
          show={showNotificationDropdown}
          anchor={notificationRef.current}
          onClose={() => setShowNotificationDropdown(false)}
          onChange={(e: any) => {
            setShowNotificationDropdown(false);
            setSelectedTaskObj(e);
          }}
          showConfirmButton={false}
        />
      </FormControl>
      <Box ml={4} mt={2}>
        <InputLabel >Trigger Type</InputLabel>
      </Box>
      <FormControl sx={{ m: 4, mt: 1, width: "-webkit-fill-available" }} size="small">
        <TextField
          select
          value={selectedTaskObj?.triggerType || ""}
          onChange={(e) => setSelectedTaskObj(prev => prev ? { ...prev, triggerType: e.target.value } : null)}
          SelectProps={{
        native: true,
          }}
        >
          <option value="">Select trigger type</option>
          <option value="todo">Trigger when task goes to TODO</option>
          <option value="completed">Trigger when task gets completed</option>
        </TextField>
      </FormControl>
      <Divider />
      <Box m={2} />
      <ActionButtons
        handleCancel={() => setHandle("")}
        handleSave={handleSave}
        //   buttonValidation={true}
      />
    </>
  );
};

export default AddTaskNotificationEmail;
